import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { AxiosCommonError } from '../../types';
import { handleError } from '../../../components/ui/err/handleError';
import { queries } from '../../queries';

export function useGetCompanyDetails(params: { companyId: number }) {
  return useQuery({
    ...queries.company.details({ companyId: params.companyId }),
    enabled: !!params.companyId && params.companyId > 0,
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
    onError: (error: AxiosError<AxiosCommonError>) => {
      handleError(error);
    },
  });
}
